/** Aceita `local@dominio.tld`, sem espaços e com TLD de pelo menos 2 letras. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

/** Comparação case-insensitive, tolerante a espaços acidentais nas pontas. */
export function emailsMatch(email: string, confirmation: string): boolean {
  return email.trim().toLowerCase() === confirmation.trim().toLowerCase();
}
